import React from "react";
import { Smartphone } from "lucide-react";
import { appStoreLinks } from "../utils/appStoreLinks";

export default function AppDownloadPromo({ compact = false }) {
  const android = appStoreLinks.android;

  return (
    <section
      aria-label="Get the Recettes Android app"
      className={`rounded-2xl border border-orange-100 bg-orange-50/40 ${compact ? "p-4" : "p-4 mb-8"}`}
    >
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-[#FF6B25] text-white shadow-sm shadow-orange-200/70">
          <Smartphone size={20} aria-hidden="true" />
        </div>
        <div className="min-w-0 flex-1">
          <h4 className="text-base font-bold leading-tight text-gray-900">
            Take Recettes Anywhere
          </h4>
          <p className="mt-1 text-sm leading-relaxed text-gray-600">
            Discover recipes, share meals, and connect with food lovers.
          </p>
          <a
            href={android.url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex w-full items-center justify-center rounded-full bg-[#FF6B25] px-4 py-2 text-sm font-bold text-white shadow-sm shadow-orange-200/70 transition hover:bg-orange-600 focus:outline-none focus:ring-2 focus:ring-orange-300 focus:ring-offset-2 sm:w-auto"
            aria-label={`${android.label} on ${android.storeName}`}
          >
            {android.label}
          </a>
          <p className="mt-2 text-xs font-medium text-gray-400">
            Available on {android.storeName}
          </p>
        </div>
      </div>
    </section>
  );
}